import { VerticalRouteConfig } from 'types/vertical'

export const VERTICAL_ROUTE_MAP: Record<string, VerticalRouteConfig> = {
  businesses: {
    id: 'businesses',
    path: '/businesses',
    tablePath: '/businesses',
    title: 'Businesses',
    iconKey: 'businessesIconUrl',
  },
  str: {
    id: 'str',
    path: '/short-term-rentals',
    tablePath: '/short-term-rentals',
    verticalPath: '/vertical/short-term-rentals/:entityId',
    title: 'Short-term Rentals',
    iconKey: 'shortTermRentalsIconUrl',
  },
  crypto: {
    id: 'crypto',
    path: '/crypto',
    tablePath: '/crypto',
    verticalPath: '/vertical/crypto/:entityId',
    title: 'Crypto',
    iconKey: 'cryptoIconUrl',
  },
  smi: {
    id: 'smi',
    path: '/influencers',
    tablePath: '/influencers',
    verticalPath: '/vertical/influencers/:entityId',
    title: 'Influencers',
    iconKey: 'influencersIconUrl',
  },
  ecommerce: {
    id: 'ecommerce',
    path: '/ecommerce',
    tablePath: '/ecommerce',
    verticalPath: '/vertical/ecommerce/:entityId',
    title: 'Ecommerce',
    iconKey: 'ecommerceIconUrl',
  },
  ecommerceSalesTax: {
    id: 'ecommerceSalesTax',
    path: '/ecommerce-extended',
    tablePath: '/ecommerce-extended',
    verticalPath: '/vertical/ecommerce-extended/:entityId',
    title: 'Ecommerce Extended',
    iconKey: 'ecommerceExtendedIconUrl',
  },
  gigEconomy: {
    id: 'gigEconomy',
    path: '/freelancers',
    tablePath: '/freelancers',
    verticalPath: '/vertical/freelancers/:entityId',
    title: 'Freelancers',
    iconKey: 'freelancersIconUrl',
  },

  offshore: {
    id: 'offshore',
    path: '/offshore',
    tablePath: '/offshore',
    title: 'Offshore',
    iconKey: 'offshoreIconUrl',
  },
  companyOverview: {
    id: 'companyOverview',
    path: '/company-overview',
    tablePath: '/company-overview',
    verticalPath: '/vertical/company-overview/:caseId',
    title: 'Company Overview',
    iconKey: 'companyOverviewIconUrl',
  },
  fatca: {
    id: 'fatca',
    path: '/fatca',
    tablePath: '/fatca',
    title: 'FATCA',
    iconKey: 'fatcaIconUrl',
  },
  serviceProvider: {
    id: 'serviceProvider',
    path: '/service-providers',
    tablePath: '/service-providers',
    verticalPath: '/vertical/service-providers/:entityId',
    title: 'Service Providers',
    iconKey: 'serviceProviderIconUrl',
  },
  nexus: {
    id: 'nexus',
    path: '/nexus',
    tablePath: '/nexus',
    verticalPath: '/vertical/nexus/:caseId',
    title: 'Nexus',
    iconKey: 'nexusIconUrl',
  },
}

const buildPathToVerticalIdMap = (): Record<string, string> => {
  const map: Record<string, string> = {}

  Object.values(VERTICAL_ROUTE_MAP).forEach(config => {
    map[config.path] = config.id
    const tablePath = config.tablePath
    if (tablePath && tablePath !== config.path) {
      map[tablePath] = config.id
    }

    if (config.verticalPath) {
      const detailPathPrefix = config.verticalPath.split('/:')[0]
      map[detailPathPrefix] = config.id
    }
  })

  return map
}

export const PATH_TO_VERTICAL_ID = buildPathToVerticalIdMap()

const extractPathPrefix = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean)

  const isVerticalDetailPage = segments[0] === 'vertical' && segments.length >= 2
  if (isVerticalDetailPage) {
    return `/${segments[0]}/${segments[1]}`
  }

  return `/${segments[0]}`
}

export const getVerticalIdFromPath = (pathname: string): string | null => {
  const pathPrefix = extractPathPrefix(pathname)
  return PATH_TO_VERTICAL_ID[pathPrefix] || null
}
